import { render, staticRenderFns } from "./RichMenuTemplateEdit.vue?vue&type=template&id=0a8b8435&"
import script from "./RichMenuTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./RichMenuTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuTemplateEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RichMenuTemplateEdit.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./RichMenuTemplateEdit.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports